
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { AccountViewModel, BudgetSummaryCriteria, ExecutionResult, IAccountBudgetSummary, ILegacyLookupService, LookupCriteria, MetadataAction } from "@tylertech/tyler-api-types";

/**
 * AccountLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class AccountLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetBudgetSummary(pCriteria: BudgetSummaryCriteria): Promise<ExecutionResult<IAccountBudgetSummary[]>> {
        return this.$apiService.sendAuth("IAccountLookupService/GetBudgetSummary", pCriteria);
    }
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<AccountViewModel[]>> {
        return this.$apiService.sendAuth("IAccountLookupService/Lookup", pCriteria);
    }
    RetrieveBudgetSummaries(AccountIds: string[]): Promise<MetadataAction> {
        return this.$apiService.sendAuth("IAccountLookupService/RetrieveBudgetSummaries", AccountIds);
    }
}
